import { useCodatAuth } from "@codat/client-cookie-manager";
import { Skeleton } from "@codat/orchard-ui";
import { PermissionsContextProvider } from "contexts/PermissionsContext";
import * as React from "react";

import Page from "components/Page";

export interface AuthorizedProps {
  usesPermissions?: boolean;
  permissionsToView?: string[];
}

export const Authorized: React.FC<React.PropsWithChildren<AuthorizedProps>> = (
  props
) => {
  const auth = useCodatAuth();
  if (auth.isLoading) {
    return (
      <Page>
        <Skeleton />
      </Page>
    );
  }

  if (!auth.userData || (auth.authType === "OIDC" && auth.userData.expired)) {
    const existingRedirect = window.sessionStorage.getItem("redirect");
    if (!existingRedirect) {
      window.sessionStorage.setItem("redirect", window.location.href);
    }
    if (auth.authType === "OIDC") {
      auth.userManager.signinRedirect();
    } else {
      auth.signIn();
    }
    return (
      <Page>
        <Skeleton />
      </Page>
    );
  }

  //Might be worth moving all the redirect to select page here from setup.ts
  //Don't love it being there

  if (!props.usesPermissions && !props.permissionsToView) {
    return <>{props.children}</>;
  }

  return (
    <PermissionsContextProvider requiredPermissions={props.permissionsToView}>
      {props.children}
    </PermissionsContextProvider>
  );
};
